export default __webpack_public_path__ + "static/media/Angel.e128b515.MOV";